import Link from 'next/link'
import { memo, useEffect, useState } from 'react'

import { PRODUCT_URL } from '@/shared/lib/const/env'
import { Popover } from '@/shared/ui/Popover'

import styles from './product-colors.module.scss'

type TCrossLink = {
	kod: string
	value: string
	label: string
	is_current: boolean
	hash: string
	in_stock: string
}
export type ProductColorsProps = {
	values?: TCrossLink[]
	groupName: string
}

export enum TriggerPopup {
	Hover = `hover`,
	Click = `click`
}

/**
 * Choose color of product
 * @param props
 * @param props.values - array of colors related products
 * @param props.groupName - title of crosslink
 */
export const ProductColors = memo(({ values, groupName }: ProductColorsProps): JSX.Element => {
	const [triggerPopup, setTriggerPopup] = useState<TriggerPopup>(TriggerPopup.Click)

	useEffect(() => {
		const query = window.matchMedia(`(min-width: 992px)`)

		setTriggerPopup(query.matches ? TriggerPopup.Hover : TriggerPopup.Click)
	}, [])

	return (
		<nav className={styles.productColors}>
			<div className={styles.productColorsInner}>
				<span className={styles.productVariantsTitle}>{groupName}</span>
				{!!values &&
					values.map(({ kod, value, label, is_current, hash, in_stock }) => (
						<Link
							prefetch={false}
							href={`${PRODUCT_URL}${kod}`}
							key={hash}
							className={`${styles.productColorsItem} ${is_current ? styles.isCurrent : ''} ${
								in_stock === 'HIDE_BUY' || in_stock === 'ARCHIVE' ? styles.outOfStock : ''
							}`}
							style={{ backgroundColor: value }}
							aria-label={`Перейти к товару цвета «${label}»`}>
							<Popover trigger={triggerPopup} overlayClassName="productColorPopover" content={label} placement="bottom">
								<div className={styles.productColorsPopoverBody} />
							</Popover>
						</Link>
					))}
			</div>
		</nav>
	)
})
